/**
 * The LMS learner query keys, in a module of their own.
 *
 * The recipients hooks mark the course Enrol dialog's roster stale on every
 * recipient, group and import change (PROD-1606 / round 6). They used to read
 * the key from `lmsCourseKeys` in use-lms-courses.ts, which pulls a whole hooks
 * module into the recipients hooks — and specs replace that module with a
 * partial mock, so a recipient save's onSuccess threw on the missing
 * `lmsCourseKeys` before it reached its toast (the recipient page's zone and
 * language confirmations, 2 Oct 2026). lmsCourseKeys.learners reads the same
 * values from here, so the two cannot drift.
 */
export const lmsLearnerKeys = {
  all: () => ['lms', 'learners'] as const,
}
